export const tiposServicosPadraoProposta = [
  { nome: "Composição Granulométrica", norma: "ABNT NBR 17054 - Concreto", tipo: "Ensaio", categoria: "Agregados" },
  { nome: "Composição Granulométrica", norma: "DNIT 031/2006-ME", tipo: "Ensaio", categoria: "Agregados" },
  { nome: "Densidade e Absorção de Água", norma: "ABNT NBR 16916", tipo: "Ensaio", categoria: "Agregados" },
  { nome: "Massa Unitária do material compactado - método A", norma: "ABNT NBR 16972", tipo: "Ensaio", categoria: "Agregados" },
  { nome: "Massa Unitária do material solto - método C", norma: "ABNT NBR 16972", tipo: "Ensaio", categoria: "Agregados" },
  { nome: "Reatividade Potencial - Método Acelerado (Cimento Obra)", norma: "ABNT NBR 15577-4 - Cimento padrão", tipo: "Ensaio", categoria: "Agregados" },
  { nome: "Equivalente de areia", norma: "DNIT 450/2024-ME", tipo: "Ensaio", categoria: "Agregado miúdo" },
  { nome: "Determinação do índice de forma pelo método do paquímetro", norma: "ABNT NBR 7809", tipo: "Ensaio", categoria: "Agregado graúdo" },
  { nome: "Desgaste por Abrasão Los Angeles", norma: "ABNT NBR 16974", tipo: "Ensaio", categoria: "Agregado graúdo" },
  { nome: "Adesividade Brita 1 + CAP", norma: "DNER-ME 078/94", tipo: "Ensaio", categoria: "Asfalto" },
  { nome: "Adesividade Brita 1 + Emulsão", norma: "DNER-ME 078/94", tipo: "Ensaio", categoria: "Asfalto" },
];

export const dadosEmpresaInicial = {
  preenchido: false,
  razaoSocial: "",
  cnpj: "",
  endereco: "",
  bairro: "",
  cidade: "",
  cep: "",
  contato: "",
  siteEmail: "",
  nomeResponsavel: "",
  empresaAssinatura: "",
  assinaturaUrl: "",
  assinaturaPath: "",
};

export const textosPadrao = {
  saudacao: "Prezado(a),",
  observacoes: "",
  apresentacao:
    "Conforme solicitação, apresentamos esta proposta para prestação de serviços de ensaio tecnológico para o empreendimento em referência.",
  prazoInicio:
    "Os trabalhos serão iniciados imediatamente após a chegada dos materiais no nosso laboratório localizado em Luzimangues, distrito de Porto Nacional - TO.",
  tituloEntrega: "Entrega dos relatórios",
  entregaRelatorios:
    "Em até 07 dias após o início dos ensaios será emitido um relatório parcial e a entrega final será de, no máximo, 32 dias a partir da data de chegada dos materiais na cidade de Palmas - TO. Vale ressaltar que o ensaio de Reação Álcali-agregado demora 30 dias para ser executado, conforme especificação normativa.",
  pagamento:
    "Após envio do relatório provisório será emitida nota fiscal com pagamento em até 15 dias.",
  validade:
    "Esta proposta tem validade de 20 dias a contar desta data. Estamos à disposição para esclarecer qualquer dúvida que se faça necessária.",
};

export function textoValidadeProposta(dias, textoFallback = textosPadrao.validade) {
  const valor = String(dias || "").trim();
  const numeroDias = /^\d+$/.test(valor) ? valor : "";

  if (!numeroDias) {
    return textoFallback || textosPadrao.validade;
  }

  return `Esta proposta tem validade de ${numeroDias} dias a contar desta data. Estamos à disposição para esclarecer qualquer dúvida que se faça necessária.`;
}

export function hojeISO() {
  return new Date().toISOString().slice(0, 10);
}

export function descricaoServico(servico = {}) {
  return [servico.nome, servico.norma].filter(Boolean).join(" - ");
}

function criarItens(servicos, prefixo, quantidade) {
  return servicos.map((servico, index) => ({
    id: `${prefixo}-${index + 1}`,
    servicoId: servico.id || "",
    unidade: "",
    quantidade,
    descricao: descricaoServico(servico),
    norma: servico.norma || "",
    valorUnitario: "",
  }));
}

export function grupoInicialProposta() {
  return {
    id: "servicos",
    titulo: "Grupo 1 - Serviços",
    subtitulo: "Valores dos serviços contratados",
    exibirSubtotal: true,
    itens: [
      {
        id: "servico-1",
        servicoId: "",
        unidade: "",
        quantidade: "",
        descricao: "",
        norma: "",
        valorUnitario: "",
      },
    ],
  };
}

export const estadoInicial = {
  codigo: "",
  revisao: "00",
  rq: "RQ 6.4",
  data: hojeISO(),
  interessadoId: "",
  interessado: "",
  empreendimentoId: "",
  empreendimento: "",
  destinatario: "",
  tituloRelatorio: "Proposta comercial",
  modeloRelatorio: "modelo1",
  email: "",
  telefone: "",
  descontoPercentual: "",
  validadeProposta: "",
  tabelas: [grupoInicialProposta()],
  textos: textosPadrao,
  dadosEmpresa: dadosEmpresaInicial,
};

export const tipoServicoInicial = {
  nome: "",
  norma: "",
  tipo: "Ensaio",
  categoria: "",
};

export function normalizarTexto(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function obraEstaAtiva(obra = {}) {
  const status = normalizarTexto(obra.status || obra.Status || "");
  return obra.ativo !== false && !["inativo", "inativa", "desativado", "desativada", "cancelado", "cancelada"].includes(status);
}

export function numero(valor) {
  if (valor === null || valor === undefined || valor === "") return 0;
  const limpo = String(valor).replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
  const convertido = Number(limpo);
  return Number.isFinite(convertido) ? convertido : 0;
}

export function moeda(valor) {
  return (Number(valor) || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function inteiroAte999PorExtenso(valor) {
  const unidades = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
  const especiais = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
  const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
  const centenas = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];
  if (valor === 100) return "cem";

  const partes = [];
  const centena = Math.floor(valor / 100);
  const resto = valor % 100;
  if (centena) partes.push(centenas[centena]);
  if (resto >= 10 && resto < 20) partes.push(especiais[resto - 10]);
  else {
    const dezena = Math.floor(resto / 10);
    const unidade = resto % 10;
    if (dezena) partes.push(dezenas[dezena]);
    if (unidade) partes.push(unidades[unidade]);
  }
  return partes.join(" e ");
}

function inteiroPorExtenso(valor) {
  if (valor === 0) return "zero";
  const escalas = [
    ["", ""],
    ["mil", "mil"],
    ["milhão", "milhões"],
    ["bilhão", "bilhões"],
    ["trilhão", "trilhões"],
  ];
  const partes = [];
  let restante = Math.floor(valor);
  let escala = 0;

  while (restante > 0 && escala < escalas.length) {
    const grupo = restante % 1000;
    if (grupo) {
      const nomeEscala = escalas[escala][grupo === 1 ? 0 : 1];
      const numeroGrupo = escala === 1 && grupo === 1 ? "" : inteiroAte999PorExtenso(grupo);
      partes.unshift([numeroGrupo, nomeEscala].filter(Boolean).join(" "));
    }
    restante = Math.floor(restante / 1000);
    escala += 1;
  }

  return partes.join(" e ");
}

export function valorMonetarioPorExtenso(valor) {
  const convertidoDireto = Number(valor);
  const valorNumerico = Number.isFinite(convertidoDireto) ? convertidoDireto : numero(valor);
  const centavosTotais = Math.round(Math.abs(valorNumerico) * 100);
  const reais = Math.floor(centavosTotais / 100);
  const centavos = centavosTotais % 100;
  const partes = [];

  if (reais || !centavos) {
    partes.push(`${inteiroPorExtenso(reais)} ${reais === 1 ? "real" : "reais"}`);
  }
  if (centavos) {
    partes.push(`${inteiroPorExtenso(centavos)} ${centavos === 1 ? "centavo" : "centavos"}`);
  }
  return partes.join(" e ");
}

export function decimalBR(valor, casas = 1) {
  return (numero(valor) || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

export function formatarDataBR(data) {
  if (!data) return "-";
  if (typeof data === "string" && data.includes("-")) {
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
  }
  if (data?.toDate) return data.toDate().toLocaleDateString("pt-BR");
  return String(data);
}

export function formatarCodigo(valor) {
  const atual = String(valor || "").trim();
  if (!atual) return "PC - 0000/0000";
  if (atual.includes("PC")) return atual;
  return `PC - ${String(atual).padStart(4, "0")}/${new Date().getFullYear()}`;
}

export function calcularProximoCodigo(propostas) {
  const ano = new Date().getFullYear();
  const numeros = propostas
    .map((item) => String(item.codigo || "").match(/(\d{1,})\/?\d{0,4}$/))
    .filter(Boolean)
    .map((match) => Number(match[1]))
    .filter(Number.isFinite);
  const proximo = numeros.length ? Math.max(...numeros) + 1 : propostas.length + 1;
  return `PC - ${String(proximo).padStart(4, "0")}/${ano}`;
}

export function calcularTotais(proposta) {
  const subtotal = (proposta.tabelas || []).reduce((totalGeral, tabela) => {
    if (tabela.exibirSubtotal === false) return totalGeral;
    const totalTabela = (tabela.itens || []).reduce(
      (total, item) => total + numero(item.quantidade) * numero(item.valorUnitario),
      0
    );
    return totalGeral + totalTabela;
  }, 0);
  const desconto = subtotal * (numero(proposta.descontoPercentual) / 100);
  return {
    subtotal,
    desconto,
    total: Math.max(0, subtotal - desconto),
  };
}

export function linhaTotal(item) {
  return numero(item.quantidade) * numero(item.valorUnitario);
}

export function numerarItensProposta(proposta = {}) {
  return {
    ...proposta,
    tabelas: (proposta.tabelas || []).map((tabela, tabelaIndex) => ({
      ...tabela,
      itens: (tabela.itens || []).map((item, itemIndex) => ({
        ...item,
        item: `${tabelaIndex + 1}.${itemIndex + 1}`,
      })),
    })),
  };
}

export function propostaComDefaults(proposta = {}) {
  return {
    ...estadoInicial,
    ...proposta,
    revisao: "00",
    rq: "RQ 6.4",
    descontoPercentual: proposta.descontoPercentual ?? "",
    textos: { ...textosPadrao, ...(proposta.textos || {}) },
    dadosEmpresa: { ...dadosEmpresaInicial, ...(proposta.dadosEmpresa || {}) },
    tabelas:
      Array.isArray(proposta.tabelas) && proposta.tabelas.length
        ? proposta.tabelas.map((tabela) => ({
            ...tabela,
            exibirSubtotal: tabela.exibirSubtotal !== false,
          }))
        : estadoInicial.tabelas.map((tabela) => ({
            ...tabela,
            itens: tabela.itens.map((item) => ({ ...item })),
          })),
  };
}


